module.exports = __webpack_public_path__ + "img/index_subtitle.550e26a5.png";